import axios from "axios";
import { server } from "../../server";

// Admin: Get verification dashboard
export const getVerificationDashboard = (status, page = 1) => async (dispatch) => {
  try {
    dispatch({ type: "getVerificationDashboardRequest" });
    let url = `${server}/verification/admin-verification-dashboard?page=${page}`;
    if (status) url += `&status=${status}`;
    const { data } = await axios.get(url, { withCredentials: true });
    dispatch({ type: "getVerificationDashboardSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "getVerificationDashboardFailed", payload: error.response?.data?.message });
  }
};

// Admin: Release vendor payment
export const releaseVendorPayment = (verificationId, adminNotes) => async (dispatch) => {
  try {
    dispatch({ type: "releasePaymentRequest" });
    const { data } = await axios.put(
      `${server}/verification/release-payment/${verificationId}`,
      { adminNotes },
      { withCredentials: true }
    );
    dispatch({ type: "releasePaymentSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "releasePaymentFailed", payload: error.response?.data?.message });
  }
};

// Customer: Approve product quality
export const approveProductQuality = (orderId, status, comment) => async (dispatch) => {
  try {
    dispatch({ type: "approveQualityRequest" });
    const { data } = await axios.put(
      `${server}/verification/customer-approve/${orderId}`,
      { status, comment },
      { withCredentials: true }
    );
    dispatch({ type: "approveQualitySuccess", payload: data });
  } catch (error) {
    dispatch({ type: "approveQualityFailed", payload: error.response?.data?.message });
  }
};

// Admin: Create verification for delivered order
export const createVerification = (orderId) => async (dispatch) => {
  try {
    dispatch({ type: "createVerificationRequest" });
    const { data } = await axios.post(
      `${server}/verification/create-verification`,
      { orderId },
      { withCredentials: true }
    );
    dispatch({ type: "createVerificationSuccess", payload: data.verification });
  } catch (error) {
    dispatch({ type: "createVerificationFailed", payload: error.response?.data?.message });
  }
};

// Admin: Auto-check all verifications
export const autoCheckVerifications = () => async (dispatch) => {
  try {
    dispatch({ type: "autoCheckRequest" });
    const { data } = await axios.post(
      `${server}/verification/auto-check-verifications`,
      {},
      { withCredentials: true }
    );
    dispatch({ type: "autoCheckSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "autoCheckFailed", payload: error.response?.data?.message });
  }
};
